export const FETCH_WISHLIST_METADATA = 'v1/wishlist-meta/FETCH_WISHLIST_METADATA';
export const ADD_TO_WISHLIST = 'v1/wishlist-meta/ADD_TO_WISHLIST';
export const REMOVE_FROM_WISHLIST = 'v1/wishlist-meta/REMOVE_FROM_WISHLIST';
export const SYNC_SESSION_WITH_CUSTOMER = 'v1/wishlist-meta/SYNC_SESSION_WITH_CUSTOMER';